import { Service } from '@genial/services';
import { selectorFamily } from 'recoil';

import { screenName } from '../constants';
import { normalizeDirectTreasuryWithdrawAsset } from '../normalize';
import { DirectTreasuryWithdrawAssetNormalized } from '../types';

export const directTreasuryWithdrawGetAsset = selectorFamily<
  DirectTreasuryWithdrawAssetNormalized | null | undefined,
  { cpfCnpj: string; productId: number }
>({
  key: 'redemptionSolicitation/directTreasuryWithdrawGetAsset',
  get: ({ cpfCnpj, productId }) => {
    return async () => {
      const { data } = await Service.Treasury.V1.getSearchAssetByCpfCnpjTitleId({
        cpfCnpj,
        screenName,
        titleId: productId,
      });

      if (!data) {
        throw new Error('Ocorreu um erro ao carregar os dados do tesouro');
      }

      const normalizedData = normalizeDirectTreasuryWithdrawAsset(data);

      return normalizedData;
    };
  },
});
